import styled from 'styled-components';

import { colors, FONT_FAMILIES } from 'common/styles/style-constants';

export const Description = styled.h4`
  font-family: ${FONT_FAMILIES.openSans};
  color: ${colors.slate};
  font-size: 16px;
`;

export const ItemsList = styled.ul`
  padding: 0;
  list-style: none;
`;
